module.exports = __webpack_public_path__ + "media/images/front/icon_youtube-d0f96eb14738bf8665f0a44b0310c374.png";